import * as moment from 'moment';

import {
	BulkAddShiftsRequest,
	BulkAssignShiftsRequest,
	BulkAssignShiftsResponse,
} from 'src/shared/api';

import { Action } from '@ngrx/store';
import { JobShiftStoreModel } from './job-shift.reducer';
import { Update } from '@ngrx/entity';

export enum JobShiftActionTypes {
	JobShiftsRequested = '[Job Assignments Page] JobShifts Requested',
	ResetJobShifts = '[Job Assignments Summary] Reset JobShifts',
	AddJobShift = '[JobShift API] Add JobShift',
	UpsertJobShift = '[JobShift] Upsert JobShift',
	AddJobShifts = '[JobShift API] Add JobShifts',
	AssignmentsAddJobShift = '[Assignments shift bar] Add JobShift',
	AssignmentsDeleteJobShift = '[Assignments shift bar] Remove JobShift',
	UpsertJobShifts = '[JobShift] Upsert JobShifts',
	UpdateJobShift = '[JobShift] Update JobShift',
	UpdateJobShifts = '[Job Summary Pane] Update JobShifts',
	BulkAssignShiftsRequested = '[Job Summary Pane] Issue Commit JobShift Assign',
	BulkAssignShiftsError = '[Job Summary Pane] Error On Commit JobShift Assign',
	SetBulkAssignShifts = '[JobShift API] BulkAssignShifts',
	DeleteJobShift = '[JobShift] Delete JobShift',
	DeleteJobShifts = '[JobShift] Delete JobShifts',
	JobAssignmentsClearJobShifts = '[Job Assignments Page] Clear JobShifts',
	JobDetailClearJobShifts = '[Job Detail Page] Clear JobShifts',
	JobDetailResetJobShifts = '[Job Detail Page] Update Job Shifts',
	RefreshJobShiftsRequested = '[Job Assignments Page] Refresh JobShifts',
	ClearShiftDeletions = '[JobShift API] Clear Shift Deletions',
	BulkAddShiftsSaved = '[Job API] Bulk AddShifts Saved',
	BulkAddShiftsRequested = '[Job Assignments Page] Bulk Add Shifts',
	UpdateStartDate = '[JobShift] Update Start Date'
}

export class JobShiftsRequested implements Action {
	readonly type = JobShiftActionTypes.JobShiftsRequested;
	constructor(public payload: { jobId: number; startDate: moment.Moment }) { }
}

export class ResetJobShifts implements Action {
	readonly type = JobShiftActionTypes.ResetJobShifts;
	constructor(public payload: { jobId: number; startDate: moment.Moment }) { }
}

export class JobDetailResetJobShifts implements Action {
	readonly type = JobShiftActionTypes.JobDetailResetJobShifts;
	constructor(public payload: { jobId: number; startDate: moment.Moment }) { }
}

export class AddJobShift implements Action {
	readonly type = JobShiftActionTypes.AddJobShift;
	constructor(public payload: { jobShift: JobShiftStoreModel }) { }
}

export class AssignmentsAddJobShift implements Action {
	readonly type = JobShiftActionTypes.AssignmentsAddJobShift;
	constructor(public payload: { jobShift: JobShiftStoreModel }) { }
}

export class AddJobShifts implements Action {
	readonly type = JobShiftActionTypes.AddJobShifts;
	constructor(public payload: { jobShifts: JobShiftStoreModel[] }) { }
}

export class UpdateJobShift implements Action {
	readonly type = JobShiftActionTypes.UpdateJobShift;
	constructor(public payload: { jobShift: Update<JobShiftStoreModel> }) { }
}

export class UpdateJobShifts implements Action {
	readonly type = JobShiftActionTypes.UpdateJobShifts;
	constructor(public payload: { jobShifts: Update<JobShiftStoreModel>[] }) { }
}

export class BulkAssignShiftsRequested implements Action {
	readonly type = JobShiftActionTypes.BulkAssignShiftsRequested;
	constructor(
		public payload: {
			bulkAssignShifts: BulkAssignShiftsRequest;
			jobId: number;
		}
	) { }
}

export class BulkAssignShiftsError implements Action {
	readonly type = JobShiftActionTypes.BulkAssignShiftsError;
}

export class SetBulkAssignShifts implements Action {
	readonly type = JobShiftActionTypes.SetBulkAssignShifts;
	constructor(
		public payload: { bulkAssignShiftsResponse: BulkAssignShiftsResponse[] }
	) { }
}

export class DeleteJobShift implements Action {
	readonly type = JobShiftActionTypes.DeleteJobShift;
	constructor(public payload: { id: string }) { }
}

export class AssignmentsDeleteJobShift implements Action {
	readonly type = JobShiftActionTypes.AssignmentsDeleteJobShift;
	constructor(public payload: { shift: JobShiftStoreModel }) { }
}

export class DeleteJobShifts implements Action {
	readonly type = JobShiftActionTypes.DeleteJobShifts;
	constructor(public payload: { ids: string[] }) { }
}

export class ClearJobShifts implements Action {
	readonly type = JobShiftActionTypes.JobAssignmentsClearJobShifts;
}

export class ClearShiftDeletions implements Action {
	readonly type = JobShiftActionTypes.ClearShiftDeletions;
}

// TODO: Add Payload for JobIds
export class JobDetailClearJobShifts implements Action {
	readonly type = JobShiftActionTypes.JobDetailClearJobShifts;
}

export class BulkAddShiftsRequested implements Action {
	readonly type = JobShiftActionTypes.BulkAddShiftsRequested;
	constructor(public payload: { shifts: BulkAddShiftsRequest }) { }
}

export class BulkAddShiftsSaved implements Action {
	readonly type = JobShiftActionTypes.BulkAddShiftsSaved;
	constructor(public payload: { shifts: BulkAddShiftsRequest }) { }
}

export class RefreshJobShiftsRequested implements Action {
	readonly type = JobShiftActionTypes.RefreshJobShiftsRequested;
}

export class UpdateStartDate implements Action {
	readonly type = JobShiftActionTypes.UpdateStartDate;
	constructor(public payload: { startDate: moment.Moment }) { }
}

export type JobShiftActions =
	| AddJobShift
	| AddJobShifts
	| AssignmentsAddJobShift
	| AssignmentsDeleteJobShift
	| BulkAddShiftsRequested
	| BulkAssignShiftsError
	| BulkAddShiftsSaved
	| BulkAssignShiftsRequested
	| ClearJobShifts
	| ClearShiftDeletions
	| DeleteJobShift
	| DeleteJobShifts
	| JobDetailClearJobShifts
	| JobDetailResetJobShifts
	| JobShiftsRequested
	| RefreshJobShiftsRequested
	| SetBulkAssignShifts
	| UpdateJobShift
	| UpdateJobShifts
	| UpdateStartDate
	;
